import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet";

function NotFound() {
  return (
    <>
    <Helmet>
  <title>404 - Page Not Found | Plan Journeys Global</title>

  <meta
    name="description"
    content="The page you are looking for could not be found. Explore travel packages, cruises, visas, destinations and holiday experiences with Plan Journeys Global."
  />

  <meta
    name="keywords"
    content="404 page, page not found, travel packages, holiday packages, cruises, visas"
  />
</Helmet>
      <Header />

      <div style={{ textAlign: "center", padding: "50px" }}>
       <img src="/assets/404.gif"></img>

       <p><a href="/" className="btn">Go Back Home</a></p> 
      </div>

      <Footer />
    </>
  );
}
     
export default NotFound;